

import * as Constant from './constant';
import Axios from "./axios/axiosInstance";
import * as XLSX  from 'xlsx';
import axios from 'axios';
import moment from "moment";
import { Slide, toast } from 'react-toastify';
const UUID = require('uuid-int');
const CryptoJS = require("crypto-js");
const sessionName='NeverTryToHack';
const sha512 = require('js-sha512');
const generator = UUID(511);

export const getUser = () => {
    const user = localStorage.getItem(sessionName);
    if(user){
        const data=decrypt(user);
        // // console.log(data)
        var parsedData=JSON.parse(data);
        // parsedData.ermissions=getPermissions();
        return parsedData;
    }
    else{
        removeSession();
        return null;
    }
}

export async function setPermissions () {
    if(isUserLogedIn()){
        return Axios.get(`/account/accessright`)
        .then((response) => {
            if (response?.data && response.status == 200) {
                const data = JSON.stringify(response?.data?.data?.accessright);
                const name=sessionName+'Permissions';
                const encrypted = encrypt(data);
                localStorage.setItem(name,encrypted);
                return true;
            }
        })
    }   
}

export function getPermissions (item) {
    if(isUserLogedIn()){
        const name=sessionName+'Permissions';
        const data = getSessiondata(name);
        if(!data) return false;
        if(item){
            var result = data.filter(x=>x.item==item);
            if(result.length>0){
                result=result[0];
                return result;
            }else{
                return false;
            }
        }else{
            return data;
        }
        
    }   
}

export const isUserLogedIn = () => {
    const user = localStorage.getItem(sessionName);
    if(user){
        const data=decrypt(user);
        if(data){
            const session=JSON.parse(data);
            // const SessionTime=new Date(session['sessionTime']).toLocaleTimeString();
            // const LocalTime=new Date().toLocaleTimeString()
            //const rrr=SessionTime>LocalTime;
            //alert(SessionTime + ' - '+ LocalTime + ' - '+ rrr);
            //return session.token;
            if(session.jwtToken){
                return true;
            }
            else{
                removeSession();
                return false;
            }
        }
    }
    else{
        removeSession();
        return false;
    }
}

export const getToken= (refreshToken=false) => {
    const user = localStorage.getItem(sessionName);
    if(user){
        const data=decrypt(localStorage.getItem(sessionName));
        const session=JSON.parse(data);
        // const SessionTime=new Date(session['sessionTime']).toLocaleTimeString();
        // const LocalTime=new Date().toLocaleTimeString()
         //const rrr=SessionTime>LocalTime;
         //alert(SessionTime + ' - '+ LocalTime + ' - '+ rrr);
         //return session.token;
        // if(SessionTime>LocalTime){
            // return refreshToken?session.refreshToken:session.jwtToken;
            return session.jwtToken;
        // }
        // else{
        //     removeSession();
        //     return null;
        // }
    }
    else{
        removeSession();
        return null;
    }
}

export const getRefreshToken= async () => {
    removeSession();
    window.location.href = '/';
}

export const setSession= async (sessionData) => {
    // var sessionValidate = new Date();
    // sessionValidate.setTime(new Date().getTime() + (sessionData.sessionTime*1000));
    // sessionData.sessionTime = sessionValidate;
    if(!sessionData.items)sessionData.items={};
    var session = JSON.stringify(sessionData);
    localStorage.setItem(sessionName,encrypt(session));
    return true;
}

export const setCartChanged= (data=true) => {
    if(isUserLogedIn()){
        var userData=getUser();
        userData.cartChanged=data;
        localStorage.setItem(sessionName,encrypt(JSON.stringify(userData)));
    }
}

export const getCartChanged= () => {
    return getUser()?.cartChanged;
}

export const removeSession= async (name) => {
    localStorage.removeItem(name??sessionName);
    localStorage.removeItem(name??sessionName+'Permissions');
}

export const encrypt= (data) => {
    try {
        if(data){
            return  CryptoJS.DES.encrypt(data, CryptoJS.enc.Utf8.parse('@Shik-SE'),{ iv: { words: [ 0, 0, 0, 0 ], sigBytes: 16 } }).toString();
        }
        else{
            return null;
        }
    } catch (error) {
        return null;
    }
}

export const decrypt= (data) => {
    try {
        if(data){
            const bytes= CryptoJS.DES.decrypt(data, CryptoJS.enc.Utf8.parse('@Shik-SE'),{ iv: { words: [ 0, 0, 0, 0 ], sigBytes: 16 } });
            return bytes.toString(CryptoJS.enc.Utf8);
        }
        else{
            return null;
        }
    } catch (error) {
        return null;
    }
}

export const getCartRef= async (force = false, refnum=false) => {
    const user = localStorage.getItem(sessionName);
    if(user){
        const data=decrypt(localStorage.getItem(sessionName));
        const session=JSON.parse(data);
        if(session['refnum'] && !force && !refnum){
            return session['refnum'];
        }
        else if(!force && refnum){
            session.refnum=refnum;
            session.cartChanged=true;
            localStorage.setItem(sessionName, encrypt(JSON.stringify(session)))
            // return session;
            return getUser();
        }
        else{
            try {
                const result = await Axios.get(`/cart/activecarth?username=${session.email}&arnum=${session.arnum}`);
                if(result.data && result.data.refnum){
                    session.refnum=result.data.refnum;
                    session.cartChanged=true;
                    localStorage.setItem(sessionName, encrypt(JSON.stringify(session)))
                    // return session;
                    return getUser();
                }
            } 
            catch (err) {
                return { status: err?.response?.status }
            }
        }
    }
    else{
        removeSession();
        return null;
    }
}


export const saveAsDraft= async (refnum) => {
    const user = localStorage.getItem(sessionName);
    if(user){
        const data=decrypt(localStorage.getItem(sessionName));
        const session=JSON.parse(data);
        if(session['refnum']){
            try {
                // api/cart/updatestatus/:refnum
                return await Axios.post(`/cart/updatestatus/${refnum??session['refnum']}`,
                {
                    status:{
                         newstatus: "draft"
                     }
                })
                .then(data=>{
                    if(data.data?.data?.updatecartstatus==='1'){
                        toast.success('Cart saved to draft successfully.', {
                            position: toast.POSITION.TOP_CENTER,
                            autoClose: 3000,
                            transition: Slide,
                        });
                        return true;
                    }else{
                        toast.error('Save to draft failed !', {
                            position: toast.POSITION.TOP_CENTER,
                            autoClose: 3000,
                            transition: Slide,
                        });
                        return false;
                    }
                });
            } 
            catch (err) {
                return { status: err?.response?.status }
            }
        }
    }
    else{
        removeSession();
        return null;
    }
}


export const submitForApproval= async (cartDetails) => {
    const user = localStorage.getItem(sessionName);
    if(user){
        const data=decrypt(localStorage.getItem(sessionName));
        const session=JSON.parse(data);
        if(session['refnum']){
            try {
                // UpdateCarth 53
                // https://devb2b.bizpoint-intl.com:3082/api/cart/update/:refnum
                return await Axios.post(`/cart/update/${session['refnum']}`,
                {
                    carth:cartDetails.carth
                }).then(async result => {
                    // api/cart/updatestatus/:refnum
                    return await Axios.post(`/cart/updatestatus/${session['refnum']}`,
                    {
                        status:{
                            newstatus: "submit"
                        }
                    })
                    .then(async data=>{
                        if(data.data?.data?.updatecartstatus==='1'){
                            toast.success('Order Submitted for Approval Successfully !', {
                                position: toast.POSITION.TOP_CENTER,
                                autoClose: 3000,
                                transition: Slide,
                            });
                            return await getCartRef(true).then(rr=>{
                                return true;
                            })
                        }else{
                            toast.error(data.data?.error??'Order Submitted for Approval Failed !', {
                                position: toast.POSITION.TOP_CENTER,
                                autoClose: 3000,
                                transition: Slide,
                            });
                            return false;
                        }
                    });
                })
                
            } 
            catch (err) {
                return { status: err?.response?.status }
            }
        }
    }
    else{
        removeSession();
        return null;
    }
}

export const getDraftItems= async () => {
    const user = localStorage.getItem(sessionName);
    if(user){
        const data=decrypt(localStorage.getItem(sessionName));
        const session=JSON.parse(data);
        if(session['refnum']){
            try {
                // api/cart/updatestatus/:refnum
                await Axios.get(`/cart/draftorders`)
                .then(data=>{
                    var data=data;
                });
            } 
            catch (err) {
                return { status: err?.response?.status }
            }
        }
    }
    else{
        removeSession();
        return null;
    }
}

export async function getDraftDeatils (force=false) {
    var userDetails = getUser();
    if(userDetails?.cartChanged || force){
        return await Axios.get(`/cart/draftorders`)
        .then(async (draft) => {
            if (draft.data && draft.data?.data?.orders) {
                return draft.data.data.orders;
            }
        })
    }
    else{
        return false;
    }
}


export async function addToWishlist (matnum) {
    var data={
        wishlist:{
             matnum: matnum
        }
   }
    // Add to Wishlist
    // /api/account/wishlist
    await Axios.post(`/account/wishlist`,data)
    .then(async (result) => {
        if (result.status == 200) {
            toast.success('Product added to wishlist successfully.', {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000,
                transition: Slide,
            });
            return true;
        }
    })
}



export async function removeFromWishlist (matnum) {
    var data={
        wishlist:{
             matnum: matnum
        }
   }
    // Remove from Wishlist
    // api/account/wishlist/:matnum
    await Axios.delete(`/account/wishlist/${matnum}`)
    .then(async (result) => {
        if (result.status == 200) {
            toast.success('Product removed from wishlist successfully.', {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000,
                transition: Slide,
            });
            return true;
        }
    })
}

export function getImageLink (link){
    if(!link)return null;
    if(link.indexOf('http') != -1){
        return link;
    }else{
        return Constant.BASE_URL+link;
    }
}

export async function addTocart (product,details,forUpdate=false,refnum=false){ 
    const userDetails=getUser();
    if(!userDetails){
        toast.warning('Please log in before add to cart.', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
            transition: Slide,
        });
        return;
    }
    var data={
        cartitem: {
            seq: product.seq??1,
            matnum: product.matnum,
            qty: details?.qty??1,
            uprice: product.sellingprice,//product.usualprice??product.uprice,
            costcenterid: "",
            catalogid: "",
            amt: product.amt,
            uuid: product.uuid??`CI-${Date.now()}`,//product.matnum
            templatedata: product.templatedata
        }
    };
    const url =`/cart/items/${refnum?refnum:userDetails.refnum}`;
    return await Axios.post(url,data)
    .then(async (cartDetails) => {
        if (cartDetails?.data && cartDetails.status == 200) {
            if(!refnum){
                if (cartDetails.data?.summary?.error) {
                    toast.error(cartDetails.data.summary.error, {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 3000,
                        transition: Slide,
                    });
                }
                else {
                    userDetails.cartChanged = true;
                    setSession(userDetails);
                    toast.success(forUpdate ? 'Cart updated successfully.' : 'Item added successfully.', {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 3000,
                        transition: Slide,
                    });
                }
                return cartDetails.data;
            }
            else{
                return true;
            }
            
        }
    })
}

export async function getCartDeatils (force=false,refnum=false,template=false) {
    if(template){
        // Get Order Template Detail
        // api/account/ordertemplate/:templatenum
        if(refnum){
            return await Axios.get(`/account/ordertemplate/${refnum}`)
            .then(async (cartDetails) => {
                if (cartDetails?.data && cartDetails.status == 200) {
                    return cartDetails.data;
                }
            })
            .catch(err => { 
                console.log(err);
            });
        }
        else{
            return false;
        }
    }else{
        var userDetails = getUser();
        if(userDetails?.cartChanged || force || refnum){
            return await Axios.get(`/cart/cartdetails/${refnum?refnum:userDetails.refnum}`)
            .then(async (cartDetails) => {
                if (cartDetails?.data && cartDetails.status == 200) {
                    userDetails.cartChanged=false;
                    if (getUser())
                    {
                        setSession(userDetails);
                        return cartDetails.data;
                    }
                    else
                        return null;
                }
            })
        }
        else{
            return false;
        }
    }
    
}

export async function updateCartDeatils (details) {
    var userDetails = getUser();
    setSession(userDetails);
    return userDetails.data;
}


export async function loadToCart (refnum=false) {
    if(refnum){
        return await Axios.post(`/cart/updatestatus/${refnum}`,
        {
            status:{
                newstatus: "open"
            }
        })
        .then(async (result) => {
            if(result?.data?.data?.updatecartstatus=='1'){
                toast.success(`Items loaded into cart successfully.`, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3000,
                    transition: Slide,
                });
                return true;
            }
            else{
                return false;
            }
        })
        .catch(e=>{
            return false;
        })
    }
    else{
        return false;
    }
    
}

export async function deleteCartItems (uuid=false,refnum=false) {
    var userDetails = getUser();
    if(userDetails?.refnum){
        var url = uuid ? `/cart/items/${refnum?refnum:userDetails.refnum}/${uuid}`:`/cart/items/${refnum?refnum:userDetails.refnum}`;
        return await Axios.delete(url)
        .then(async (cartDetails) => {
            if (cartDetails?.data && cartDetails.status == 200) {
                if(!refnum){
                    userDetails.cartChanged=true;
                    setSession(userDetails);
                    toast.success('Cart Cleared Successfully.', {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 3000,
                        transition: Slide,
                    });
                    return cartDetails.data;
                }
                else{
                    return true;
                }
                
            }
        })
    }
    else{
        return false;
    }
}

export async function deleteShippingAddress (item) {
    if(item){
        // https://devb2b.bizpoint-intl.com:3082/api/profile/location/:arnum/
        return await Axios.delete(`/profile/location/${item.arnum}/${item.uuid}`)
        .then(async (data) => {
            if(data.status === 200){
                toast.success('Address Deleted Successfully', {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3000,
                    transition: Slide,
                });
                return true;
            }
            else{
                toast.error('Address not deleted ', {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3000,
                    transition: Slide,
                });
                return false;
            }
        })
    }
    else{
        return false;
    }
}

export async function sortByProducts () {
    const name=sessionName+'SortBy'
    const user = localStorage.getItem(name);
    if(user){
        const data=decrypt(user);
        return data;
    }
    else{
        return '';
    }
}

export async function addSortByProducts (data) {
    const name=sessionName+'SortBy'
    localStorage.setItem(name,encrypt(data));
    return data;
}

export async function recentsProducts () {
    const name=sessionName+'Recents'
    return getSessiondata(name);
}

export async function addToRecents (matnum) {
    const name=sessionName+'Recents'
    var recentProducts = getSessiondata(name);
    if(!recentProducts)recentProducts=[]
    if(recentProducts.includes(matnum)){
        return false;
    }
    recentProducts.push(matnum);
    recentProducts=removeDuplicates(recentProducts).slice(-5);
    setSessiondata(recentProducts,name);
    return recentProducts;
}

export async function productDetails () {
    const name=sessionName+'Product'
    return getSessiondata(name);
}

export async function setProductDetails (matnum) {
    const name=sessionName+'Product'
    var recentProducts = getSessiondata(name);
    recentProducts = matnum;
    setSessiondata(recentProducts,name);
    return recentProducts;
}

export async function selectedColours () {
    const name=sessionName+'Colours'
    const user = localStorage.getItem(name);
    if(user){
        const data=decrypt(user);
        return data;
    }
    else{
        return '';
    }
}

export async function addToColours (colour) {
    const name=sessionName+'Colours'
    
    var recentProducts = localStorage.getItem(name);
    recentProducts=colour;
    localStorage.setItem(name,encrypt(recentProducts));
    return recentProducts;
}

export async function removeColours (colour) {
    const name=sessionName+'Colours'
    removeSession(name);
    return null;
}

export async function selectedLabels () {
    const name=sessionName+'Labels'
    const user = localStorage.getItem(name);
    if(user){
        const data=decrypt(user);
        return data;
    }
    else{
        return '';
    }
}

export async function addToLabels (label) {
    const name=sessionName+'Labels'
    
    var recentProducts = localStorage.getItem(name);
    recentProducts=label;
    localStorage.setItem(name,encrypt(recentProducts));
    return recentProducts;
}

export async function removeLabels () {
    const name=sessionName+'Labels'
    removeSession(name);
    return null;
}

export async function compareProducts () {
    const name=sessionName+'Compares'
    return getSessiondata(name);
}

export async function addToCompares (matnum) {
    const name=sessionName+'Compares'
    
    var recentProducts = getSessiondata(name);
    if(!recentProducts)recentProducts=[];
    if(recentProducts.includes(matnum)){
        toast.warning('Product already added to compare list', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
            transition: Slide,
        });
        return false;
    }else{
        toast.success('Product added to compare list successfully.', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
            transition: Slide,
        });
    }
    recentProducts.push(matnum);
    recentProducts=removeDuplicates(recentProducts).slice(-3);
    setSessiondata(recentProducts,name);
    return recentProducts;
}

export async function removeFromCompares (matnum) {
    const name=sessionName+'Compares'
    toast.success('Product removed from compare list successfully.', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
        transition: Slide,
    });
    var recentProducts = getSessiondata(name);
    if(!recentProducts)recentProducts=[];
    if(matnum){
        recentProducts = recentProducts.filter(function(item) {
            return item !== matnum
        })
    }else{
        recentProducts=[];
    }
    setSessiondata(recentProducts,name);
    return recentProducts;
}

function removeDuplicates(arr) {
    return arr.filter((item,
        index) => arr.indexOf(item) === index);
}

export const getSessiondata = (name) => {
    const user = localStorage.getItem(name);
    if(user){
        const data=decrypt(user);
        // // console.log(data)
        const jsonData = JSON.parse(data);
        return jsonData;
    }
    else{
        return null;
    }
}
export const setSessiondata = (sessionData,name, ignoreItem=false) => {
    if(!sessionData.items && !ignoreItem)sessionData.items={};
    var session = JSON.stringify(sessionData);
    localStorage.setItem(name,encrypt(session));
    return true;
}

export async function updatePaymentStatus (details,status=1) {
    var data={
        "payment": {
            "cartrefnum": details.refnum,
            "status": status==1?"initiated":status==2?"completed":"failed",
            "response": details.paymentResponse
        }
    }
    // Update payment status
    // api/payment/status
    return await Axios.post(`/payment/status`,data)
    .then(async (response) => {
        if (response?.data && response.status == 200) {
            if(status!=1)removeSession("WaitingForPayment");
            return true;
        }
    })
}

export async function redirectUrlForPayment (orderId,amount) {
    if(amount){
        const token = getToken();
        const baseUrl= window.location.protocol + '//' + window.location.host;
        var requestData = {
            "request_url": baseUrl,
            "order_id": orderId,
            "amount": amount.toString(),
            "api_mode": "redirection_hosted",
            "merchant_reference": "the things to reference",
            "token": token
        }

        var requestBody = {
            requestData:JSON.stringify(requestData)
        }

        return await axios.post(`${Constant.BASE_AUTH_URL}/accounts/redirectUrlForPayment`,requestBody)
        .then((result) => {
            if (result?.data) {
                return result.data;
            }
        })
        .catch((err) => {
            toast.error(err.message, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000,
                transition: Slide,
            });
            return false;
        })
    }
}

export async function downloadFile (url) {
    try{
        var config = {
            headers: {
                "Authorization": `Bearer ${getToken()}`,
                "Access-Control-Allow-Origin":"*",
                "requesterID": "B2BFront",
                "requestTnxID": `B${generator.uuid()}`,
                "requestDateTime": Date.now(),
                "requestHash": generator.uuid()
              },
        };

        await axios({
            url: Constant.BASE_URL+"/api"+url,
            method: 'GET',
            responseType: 'blob', // important
        },config)
        .then(response =>{
            window.URL.createObjectURL(new Blob([response.data]))
        })
        .catch(e=>{
            console.log(e)
        })
    }
    catch(e){
        return false;
    }
    
}

export async function readFileAsJson (file,callBackFunction) {
    try{
        const reader = new FileReader();
        reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);
        callBackFunction(jsonData);
        };
        reader.readAsArrayBuffer(file);
    }
    catch(e){
        return false;
    }
    
}

export async function checkPayment (transaction_Id,refnum) {
    if(transaction_Id){
        var requestData = {
            "transaction_id": transaction_Id
        }
        return axios.post(`${Constant.BASE_AUTH_URL}/accounts/checkPayment`,requestData)
        .then((result) => {
            if (result?.data) {
                var data={
                    "payment": {
                        "cartrefnum": refnum,
                        "status": "completed",
                        "type" : "redirection",
                        "response": result?.data,
                    }
                }
                return axios.post(`${Constant.BASE_URL}/api/payment/status`,data)
                .then((result2) => {
                    if (result2?.data) {
                        return result.data;
                    }
                });
            }
        })
        .catch((err) => {
            toast.error(err.message, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000,
                transition: Slide,
            });
            return false;
        })
    }
}


export async function recaptchaVerify (token) {
    if(!token)return false;
    return await axios.post(
    `https://www.google.com/recaptcha/api/siteverify?secret=${Constant.ReCAPTCHA_SECRET_KEY}&response=${token}`)
    .then(res=>{
        if (res.status(200)) {
            return true;
        }else{
            return false;
        }
    })
  
}

export function checkNumber(x) {

    // check if the passed value is a number
    if(typeof x == 'number' && !isNaN(x)){
    
        // check if it is integer
        if (Number.isInteger(x)) {
            return true;
        }
        else {
            return true;
        }
    
    } else {
        return false;
    }
}

export function isFloat(val) {
    var floatRegex = /^-?\d+(?:[.,]\d*?)?$/;
    if (!floatRegex.test(val))
        return false;

    val = parseFloat(val);
    if (isNaN(val))
        return false;
    return true;
}

export function isInt(val) {
    var intRegex = /^-?\d+$/;
    if (!intRegex.test(val))
        return false;

    var intVal = parseInt(val, 10);
    return parseFloat(val) == intVal && !isNaN(intVal);
}

export function getTodayDate() {
    return moment(new Date()).format("YYYY-MM-DD");
}

export function getDate(date) {
    return moment(new Date(date)).format("YYYY-MM-DD");
}